import classnames from 'classnames';
import _ from 'lodash';
import React from 'react';

type ToggleButtonData = {
  label?: string;
  value?: string | boolean | number;
};

export type ToggleButtonProps = {
  id?: string;
  className?: string;
  isActive: boolean;
  disabled?: boolean;
  name?: string;
  subLabel?: string;
  data: ToggleButtonData;
  onClick: (name: string | undefined, value: string | boolean | number | undefined) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
  count?: number;
};

const ToggleButton = ({
  id,
  className,
  isActive,
  disabled = false,
  name = '',
  subLabel = '',
  data,
  onClick,
  onKeyDown = () => {},
  count,
}: ToggleButtonProps) => {
  /**
   * Reports the toggle button's selection back to its parent. Invokes the onClick prop with the button's name and the value carried by its data option.
   *
   * @returns Nothing.
   */
  const handleClick = () => {
    onClick(name, data.value);
  };

  return (
    <button
      id={id}
      disabled={disabled}
      onKeyDown={onKeyDown}
      onClick={handleClick}
      className={classnames('toggle-button', isActive ? '--active' : '', className)}
    >
      <span className={classnames('content', !_.isNil(count) ? 'pe-2' : '')}>
        {data.label}
        {subLabel}
      </span>
      {!_.isNil(count) && <span className="count">{count}</span>}
    </button>
  );
};

export default ToggleButton;
